import React from 'react'
import { today } from './inventoryData';
import { Field, PanelTitle } from './InventoryShared';

function PurchaseEntryPage({ items, suppliers }) {
    return (
        <section className='inventory-panel inventory-form-page'>
            <PanelTitle title='Purchase Entry' />
            <div className='inventory-form-grid two-column'>
                <Field label='Supplier Name' type='select' options={suppliers.map(item => item.name)} />
                <Field label='Invoice Number' placeholder='INV-1024' />
                <Field label='Purchase Date' type='date' defaultValue={today} />
                <Field label='Item Name' type='select' options={items.map(item => item.name)} />
                <Field label='Quantity' type='number' placeholder='20' />
                <Field label='Price' type='number' placeholder='4500' />
                <Field label='GST' type='number' placeholder='5' />
            </div>
            <div className='inventory-upload-zone'>Upload Invoice<br /><small>Drag and drop invoice PDF/image here</small></div>
            <div className='inventory-actions sticky'><button>Save Purchase</button></div>
        </section>
    );
}

export default PurchaseEntryPage
